import { chakra } from '@stockx/ui';

export const NavBarWrapper = chakra('nav', {
  baseStyle: {
    background: 'neutral.white',
    minHeight: { base: '44px', md: '90px' },

    '.navbar-brand': {
      display: 'block',
      margin: { base: 'auto', md: 0 },
      padding: 0,
      lineHeight: { base: '42px', md: '90px' },
      height: { base: '44px', md: '90px' },
      textAlign: 'center',
      ' svg': {
        display: 'inline-block',
        lineHeight: '44px',
        margin: 'auto',
      },
    },

    '.navbar-search': {
      width: { base: 'auto', md: '90%' },
      margin: '0 auto',
      flexGrow: 1,
      paddingRight: { base: 0, md: 8 },

      // This pattern needs to be fleshed out
      // and moved into Anvil (mobile size, position)
      '.chakra-input__left-element': {
        left: { base: '1', md: '0' },
        top: { base: '0.5', md: '0' },
        width: { base: '2rem', md: '3rem' },
        height: { base: '2rem', md: '3rem' },
      },

      input: {
        borderRadius: 0,
        backgroundColor: 'neutral.100',
        paddingRight: 2,
        boxShadow: 'none',
        height: { base: '34px', md: '44px' },
        textOverflow: 'ellipsis',
        color: 'neutral.black',
        fontSize: '14px',

        '&::placeholder': {
          color: 'neutral.black',
        },
      },
    },

    '.clear-ask': {
      display: 'inline-block',
      padding: { md: '4px 10px', lg: '5px 15px' },
      fontWeight: 600,
      lineHeight: '22px',
      color: 'neutral.black',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'neutral.black',

      _hover: {
        background: 'none',
      },
    },

    '&.home-page, &.blog-header': {
      transition: 'all 0.5s ease',

      ' li .localization-container': {
        color: 'neutral.white',
      },
      '.currency-dropdown-container': {
        color: 'neutral.white',
      },

      '.clear-ask': {
        borderColor: 'neutral.black',
      },

      '&.visible': {
        background: 'neutral.white',

        '.nav-main-wrapper > li > a': {
          color: 'neutral.black',
        },
        ' li .localization-container': {
          color: 'neutral.black',
        },
        '.currency-dropdown-container': {
          color: 'neutral.black',
        },
        '.clear-ask': {
          borderColor: 'neutral.black',
        },
      },
    },
    '&.blog-header': {
      '.desktop-logo-wrapper': {
        display: 'none',
      },
    },
  },
});

export const NavBarButtonStyles = {
  '> button': {
    width: '100%',
  },
};
